<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataBackups',
});

// Базовый тип для сообщений с временной меткой
type BackupWithTime = {
  time: number;
};

// Типы для WebSocket сообщений компонента backups
type BackupListMessage = WebSocketMessageWithFields<'backup-list', {
  backupTypes: unknown[];
  backups: unknown[];
  backupInProgress: boolean;
}>;
type BackupCreateMessage = WebSocketMessageWithFields<'backup-create' | 'backup-create-start', BackupWithTime & {
  dir: string;
  name: string;
  type: string;
  databaseMain: boolean;
  databasePrice: boolean;
  finished: boolean;
}>;
type BackupCreateSuccessMessage = WebSocketMessageWithFields<'backup-create-success', BackupWithTime>;
type BackupCreateErrorMessage = WebSocketMessageWithFields<'backup-create-error', BackupWithTime>;
type BackupDeleteMessage = WebSocketMessageWithFields<'backup-delete' | 'backup-delete-success', BackupWithTime>;
type BackupRestoreMessage = WebSocketMessageWithFields<'backup-restore' | 'backup-restore-start', BackupWithTime>;
type BackupRestoreSuccessMessage = WebSocketMessageWithFields<'backup-restore-success', BackupWithTime>;
type BackupRestoreErrorMessage = WebSocketMessageWithFields<'backup-restore-error', BackupWithTime>;

// Объединенный тип для всех сообщений
type BackupsWebSocketMessage = 
  | BackupListMessage 
  | BackupCreateMessage 
  | BackupCreateSuccessMessage 
  | BackupCreateErrorMessage 
  | BackupDeleteMessage 
  | BackupRestoreMessage 
  | BackupRestoreSuccessMessage 
  | BackupRestoreErrorMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: BackupsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'backup-list':
      store.dispatch('backups/wsSetBackups', {
        backups: data.backups,
        backupInProgress: data.backupInProgress,
      });
      store.dispatch('backups/wsSetBackupTypes', {
        backupTypes: data.backupTypes,
      });
      break;

    case 'backup-create':
    case 'backup-create-start':
      store.dispatch('backups/wsBackupCreate', {
        dir: data.dir,
        time: data.time,
        name: data.name,
        type: data.type,
        databaseMain: data.databaseMain,
        databasePrice: data.databasePrice,
        finished: data.finished,
      });
      break;

    case 'backup-create-success':
      store.dispatch('backups/wsBackupCreateSuccess', {
        time: data.time,
      });
      break;

    case 'backup-create-error':
      store.dispatch('backups/wsBackupCreateError', {
        time: data.time,
      });
      break;

    case 'backup-delete':
    case 'backup-delete-success':
      store.dispatch('backups/wsBackupDelete', {
        time: data.time,
      });
      break;

    case 'backup-restore':
    case 'backup-restore-start':
      store.dispatch('backups/wsBackupRestore', {
        time: data.time,
      });
      break;

    case 'backup-restore-success':
      store.dispatch('backups/wsBackupRestoreSuccess', {
        time: data.time,
      });
      break;

    case 'backup-restore-error':
      store.dispatch('backups/wsBackupRestoreError', {
        time: data.time,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
